import { render, staticRenderFns } from "./monaco.vue?vue&type=template&id=737cadcc&scoped=true&"
import script from "./monaco.vue?vue&type=script&lang=js&"
export * from "./monaco.vue?vue&type=script&lang=js&"
import style0 from "./monaco.vue?vue&type=style&index=0&id=737cadcc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737cadcc",
  null
  
)

export default component.exports